import React, { useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Modal from '@material-ui/core/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { PPSI } from '@ikea-food-ux/ppsi';
// import { getUtensils } from '../../UtensilContainer/selectors';
import { getOverviewLabels } from '../../app/overviewLabelSelectors';
import { getTimeUnits } from '../../app/timeUnitSelectors';
import { getTemperatureUnits } from '../../app/temperatureUnitSelectors';
import { getStockHierarchy } from '../../app/stockHierarchySelectors';
import { getProductions } from '../../app/productionSelectors';
import { getConfigs, getLanguage } from '../../app/selectors';
import useUtensils from '../../UtensilContainer/hooks/useUtensils';
import { getShelfLifeTimeUnitsUnits } from 'features/app/shelfLifeTimeUnitsSelectors';
import { setPPSIId } from '../actions';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center'
  },
  content: {
    width: '90%',
    minWidth: 600,
    maxWidth: 1000,
    maxHeight: '90%',
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    outline: 0,
    borderRadius: '3px'
  }
}));

const usePreviewPpsi = () => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState();
  const labels = useSelector(getOverviewLabels).toJS();
  const timeUnits = useSelector(getTimeUnits).toJS();
  const [hideBackButton, setHideBackButton] = useState(false);
  const temperatureUnits = useSelector(getTemperatureUnits).toJS();
  const stockHierarchy = useSelector(getStockHierarchy).toJS();
  const productionOptions = useSelector(getProductions).toJS();
  // const utensils = useSelector(getUtensils).toJS();
  const marketLanguage = useSelector(getLanguage);
  const [utensils] = useUtensils();
  const unitSystem = useSelector(getConfigs).toJS().ifoodPPSIUnitSystem;
  const shelfLifeTimeUnits = useSelector(getShelfLifeTimeUnitsUnits).toJS();
  let getGlobalUtensils =
    utensils && utensils.filter(i => i.code.includes('IFS'));
  const dispatch = useDispatch();

  if (getGlobalUtensils && data) {
    getGlobalUtensils = getGlobalUtensils.map(itm => ({
      ...itm,
      info: { ...itm.info, [data.language]: itm.info[marketLanguage] }
    }));
  }

  function open(ppsi, language) {
    setIsOpen(true);
    setData({ ppsi, language });
    if (ppsi.hideBackButton) {
      setHideBackButton(true);
    }
  }
  function close() {
    setIsOpen(false);
    setData(null);
    dispatch(setPPSIId(null));
  }
  const element = (
    <Modal open={isOpen} onClose={close} className={classes.root}>
      <div className={classes.content} id="scrollable">
        {data && data.ppsi ? (
          <PPSI
            containGlobalUpdate={
              data.ppsi.updateNotificationList.length
                ? !!data.ppsi.updateNotificationList[0].ppsiUpdates
                : false
            }
            ppsi={data.ppsi}
            labels={labels}
            timeUnits={timeUnits}
            temperatureUnits={temperatureUnits}
            stockHierarchy={stockHierarchy}
            productionOptions={productionOptions}
            language={data.language}
            utensils={getGlobalUtensils}
            unitSystem={unitSystem}
            hideBackButton={hideBackButton}
            shelfLifeTimeUnits={shelfLifeTimeUnits}
          />
        ) : (
          <>No PPSI Data :(</>
        )}
      </div>
    </Modal>
  );

  return [element, open, close];
};

export default usePreviewPpsi;
